import { createSlice } from "@reduxjs/toolkit";

export const immigrationsSlice = createSlice({
  name: "immigrations",
  initialState: {
    loading: false,
    error: null,
    immigrations: {},
    currentImmgration: {},
    currentLca: {},
    allImmigrations:{},
    currentEmployeeImmigration:{},
  },
  reducers: {
    getAllImmigrationsStart(state, action) {
      state.loading = true;
      state.immigrations = {};
    },
    getAllImmigrationsSuccess(state, action) {
      state.loading = false;
      state.error = null;
      state.immigrations = action.payload;
    },
    getAllImmigrationsFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    /////////////////////////////////

    getImmigrationsByUiidStart(state, action) {
      state.loading = true;
      state.immigrations = {};
    },
    getImmigrationsByUiidSuccess(state, action) {
      state.loading = false;
      state.error = null;
      state.immigrations = action.payload;
    },
    getImmigrationsByUiidFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    /////////////////////////////////
    addNewImmigrationsStart(state) {
      state.loading = true;
      state.error = null;
    },
    addNewImmigrationsSuccess(state) {
      state.loading = false;
    },
    updateImmigrationsStart(state) {
      state.loading = false;
      state.error = null;
    },
    addNewImmigrationsFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    addCurrentImmigrations(state, action) {
      const data = action.payload;
      console.log("---data",data);
      if (!data || typeof data !== "object" || Object.keys(data).length === 0) {
        console.log("---kk");
        state.currentImmgration = {};
      } else {
        state.currentImmgration = {
          ...state.currentImmgration,
          ...data,
        };
      }
    },
    addNewLcaStart(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    successAddNewLca(state,action){
      const data = action.payload;
   if (!data || typeof data !== "object" || Object.keys(data).length === 0) {
        state.currentLca = {};
      } else {
        state.currentLca = {
          ...state.currentLca,
          ...data,
        };
      }
    },
    getAllImmigrations(state,action){
       state.loading=true;
       state.error = null;
    },
    successAllImmigrations(state,action){
      state.loading=false;
      const data=action.payload
      state.allImmigrations={
        ...state.allImmigrations,
        ...data
      }
    },
    getFailureImmigrations(state,action){
      state.loading=false;
      state.error=action.payload 
    },
    getCurrentEmployeeImmigration(state,action){
      state.loading=true;
      state.error = null;
    },
    successGetCurrentEmployeeImmigration(state,action){
      state.loading=false;
      const data=action.payload
      console.log("data",data);
      state.currentEmployeeImmigration={
        ...state.currentEmployeeImmigration,
        ...data
      }
    },
    // failureGet
  },
});

export const {
  getAllImmigrationsStart,
  getAllImmigrationsSuccess,
  getAllImmigrationsFailure,
  getImmigrationsByUiidStart,
  getImmigrationsByUiidSuccess,
  getImmigrationsByUiidFailure,
  addNewImmigrationsStart,
  addNewImmigrationsSuccess,
  addNewImmigrationsFailure,
  addCurrentImmigrations,
  updateImmigrationsStart,
  addNewLcaStart,
  successAddNewLca,
  getAllImmigrations,
  successAllImmigrations,
  getFailureImmigrations,
  getCurrentEmployeeImmigration,
  successGetCurrentEmployeeImmigration,
} = immigrationsSlice.actions;

export default immigrationsSlice.reducer;
